<template>
  <div class="mainGlobeScene">
    <!--文件名-->
    <div style="margin:0 8px 23px 8px;display:flex;">
      <v-menu offset-y nudge-bottom="12" nudge-left="9" min-width="186">
        <template v-slot:activator="{ on, attrs }">
          <div v-show="!$store.state.sceneItemDragging && !$store.state.sceneItemMultipleChoosing" v-bind="attrs" v-on="on" style="width:20px;height:16px;margin-right:15px;cursor:pointer;">
            <p style="font-size:18px;" class="iconfontFamily">&#xe662;</p>
          </div>
        </template>
        <div style="width:100%;background: #383838;border:1px solid transparent;box-shadow: 0px 0px 4px 0px #000000;border-radius:3px;padding:6px 0;">
          <div @click="createNewFolder" class="moreOperationItem">
            <p>新建录制</p>
          </div>
          <div @click="beginChooseFolder" class="moreOperationItem">
            <p>打开文件</p>
          </div>
          <div @click="saveFolder" class="moreOperationItem">
            <p>保存文件</p>
          </div>
          <div @click="beginResaveFolder" class="moreOperationItem">
            <p>另存为</p>
          </div>
          <div @click="" class="moreOperationItem">
            <p>录制设置</p>
          </div>
          <div style="color:#A6A6A6" class="moreOperationItem">
            <p>帮助</p>
          </div>
          <div style="color:#A6A6A6" class="moreOperationItem">
            <p>素材中心</p>
          </div>
          <div style="width:157px;height:1px;background:#545454;margin:0 auto;"></div>
          <div class="moreOperationItem">
            <p @click="openGlobeSet">地图设置</p>
          </div>
        </div>
      </v-menu>
      <!--文件名及编辑-->
      <div v-show="!$store.state.sceneItemMultipleChoosing" style="flex:1;">
        <p @dblclick="$store.state.sceneItemDragging || $store.state.sceneItemMultipleChoosing ? '' : intoEditSceneName($event)"
            v-show="!editSceneNameShow" style="line-height:28px;font-size:18px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;">{{currSceneName}}</p>
        <v-textarea ref='sceneNameTextarea' @blur="editSceneNameOk" v-show="editSceneNameShow" v-model="currSceneName" dark auto-grow hide-details no-resize rows="1" row-height="28" class="editSceneNameTextField"></v-textarea>
      </div>
      <p v-show="$store.state.sceneItemMultipleChoosing" style="line-height:28px;flex:1;">{{$store.state.sceneItemMultipleChoosingList.length}} 选中</p>


      <v-menu offset-x nudge-right="9" min-width="105">
        <template v-slot:activator="{ on, attrs }">
          <div v-show="$store.state.sceneList.length > 0 && !$store.state.sceneItemDragging && !$store.state.sceneItemMultipleChoosing" v-bind="attrs" v-on="on" style="margin-left:15px;cursor:pointer;">
            <p style="font-size:18px;cursor:pointer;" class="iconfontFamily">&#xe6a3;</p>
          </div>
        </template>
        <div style="width:100%;background: #383838;border:1px solid transparent;box-shadow: 0px 0px 4px 0px #000000;border-radius:3px;padding:6px 0;">
          <div @click="intoSceneItemDragging" class="moreOperationItem">
            <p>顺序调整</p>
          </div>
          <div @click="intoSceneItemMultipleChoosing" class="moreOperationItem">
            <p>批量操作</p>
          </div>
        </div>
      </v-menu>

      <!--排序操作按钮-->
      <div v-show="$store.state.sceneItemDragging" style="display:flex;">
        <div @click="$store.state.sceneItemDragging = false;" style="width:40px;height:100%;text-align:center;cursor:pointer;">
          <p style="line-height:28px;">取消</p>
        </div>
        <div @click="sceneItemDraggingOK" style="width:40px;height:100%;margin-left:5px;text-align:center;cursor:pointer;">
          <p style="line-height:28px;">确认</p>
        </div>
      </div>
      <!--批量删除操作按钮-->
      <div v-show="$store.state.sceneItemMultipleChoosing" style="display:flex;">
        <div @click="sceneItemMultipleDelete" style="width:40px;height:100%;text-align:center;cursor:pointer;">
          <p style="line-height:28px;">删除</p>
        </div>
        <div @click="$store.state.sceneItemMultipleChoosing = false;" style="width:40px;height:100%;margin-left:5px;text-align:center;cursor:pointer;">
          <p style="line-height:28px;">取消</p>
        </div>
      </div>



    </div>

    <div style="flex:1;overflow:hidden;">
      <!--无内容-->
      <div v-if="$store.state.sceneList.length === 0" style="height:100%;margin-top:12px;display:flex;flex-direction:column;align-items:center;">
        <p style="margin-top:22px;color:#979797;font-size:14px;">暂无内容</p>
        <div style="width:calc(100% - 40px);height:1px;margin:18px 0 23px 0;background:#636262;"></div>
        <p @click="openSceneGuideVideo" style="width:116px;color:#63ACFF;font-size:14px;cursor:pointer;">
          <span style="margin-right:4px;font-size:16px;" class="iconfontFamily">&#xe778;</span>
          如何开始录制
        </p>
        <v-spacer></v-spacer>

        <!--样例数据-->
        <div :style="{'height':sceneExampleShow ? 'auto' : '54px'}"
             style="width:100%;margin:0 auto;background:#262626;border-radius:4px;padding:12px 10px 20px 12px;">
          <div style="margin-bottom:11px;display:flex;align-items: center;">
            <p style="font-size:14px;">样例作品</p>
            <v-spacer></v-spacer>
            <p @click="sceneExampleShow = !sceneExampleShow" style="font-size:14px;cursor:pointer;">
              {{sceneExampleShow ? '隐藏' : '展开'}}
              <span style="margin-left:4px;" class="iconfontFamily">{{sceneExampleShow ? '&#xe65b;' : '&#xe722;'}}</span>
            </p>
          </div>
          <div v-show="sceneExampleShow">
            <div style="overflow:hidden;">
              <div @click="addExampleToSceneList(item.id)" v-for="(item,index) in $store.state.sceneExampleList.length > 4 ? $store.state.sceneExampleList.slice(0,4) : $store.state.sceneExampleList"
                   :key="'example'+index" style="position:relative;width:120px;height:90px;float:left;cursor:pointer;margin:0 13px 10px 13px;">
                <v-img :src="item.picture" style="position:absolute;top:0;left:0;width:100%;height:100%;"></v-img>
                <div style="position:absolute;bottom:0;left:0;width:100%;height:21px;background:rgba(0, 0, 0, 0.6);padding:0 5px;">
                  <p style="line-height:22px;font-size:12px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;">{{item.labelName}}</p>
                </div>
              </div>
            </div>
            <div @click="$parent.sceneExampleDialogShow = true" style="width:40px;height:22px;margin:0 auto;font-size:16px;color:#2A82E4;text-align:center;cursor:pointer;">
              更多
            </div>
          </div>

        </div>
      </div>


      <!--有场景内容-->
      <div v-if="$store.state.sceneList.length !== 0" style="height:100%;display:flex;flex-direction:column;">

        <div style="padding-top:2px;flex:1;overflow:auto;" class="myScrollArea">
          <div v-for="(item,index) in $store.state.sceneItemDragging ? $store.state.tempSceneList : $store.state.sceneList" :key="'sceneItem'+index"
               :draggable="$store.state.sceneItemDragging" @dragstart="sceneItemDragstart(index)" @dragover="sceneItemDragover($event, index)"
               @drop="sceneItemDragend($event,index)" @dragleave="sceneItemDragleave($event,index)"
               style="position:relative;">
            <!--录制点信息-->
            <div @click="$store.state.sceneItemDragging || $store.state.sceneItemMultipleChoosing ? '' : clickSceneItem(item,index)" :style="{'background':$store.state.currChooseSceneItemId === item.sceneId && !item.flyAnimationShow ? '#262626' : 'transparent',
               'border-color':($store.state.currChooseSceneItemId === item.sceneId && !item.flyAnimationShow)
               || ($store.state.sceneItemMultipleChoosing && $store.state.sceneItemMultipleChoosingList.indexOf(item.sceneId)!==-1) ? '#00B3FF' : '#808080'}"
                 class="sceneItem">
              <!--基本信息-->
              <div style="position:relative;display:flex;align-items:center;">
                <p style="width:20px;">{{index+1}}</p>
                <div style="width:44px;height:44px;margin-left:9px;">
                  <v-img v-if="item.sceneThumb!==''" :src="item.sceneThumb" style="width:100%;height:100%;cursor:pointer;" />
                  <div v-else style="width:100%;height:100%;background:rgba(56, 56, 56, 1);text-align:center;">
                    <p style="color:#808080;font-size:12px;line-height:50px;">加载中</p>
                  </div>
                </div>
                <div style="margin-left:14px;flex:1;overflow:hidden;">
                  <p @dblclick="$store.state.sceneItemDragging || $store.state.sceneItemMultipleChoosing ? '' : intoEditSceneItemName($event,item)" v-show="!editSceneItemNameShow" style="line-height:22px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{item.sceneName}}</p>
                  <v-text-field @blur="editSceneItemNameShow = false" v-show="editSceneItemNameShow" v-model="item.sceneName"
                                dark height="22" hide-details class="editSceneItemNameTextField"></v-text-field>
                </div>
                <p @click="previewSceneItem(item)" v-show="!$store.state.sceneItemDragging && !$store.state.sceneItemMultipleChoosing"
                   :style="{'display':$store.state.currChooseSceneItemId === item.sceneId && !item.flyAnimationShow ? 'block' : ''}" class="sceneItem-btn mr-3 ml-1 iconfontFamily">&#xe65e;</p>
                <p @click.stop="deleteSceneItem(index)" v-show="!$store.state.sceneItemDragging && !$store.state.sceneItemMultipleChoosing"
                   :style="{'display':$store.state.currChooseSceneItemId === item.sceneId && !item.flyAnimationShow ? 'block' : ''}" class="sceneItem-btn iconfontFamily">&#xe720;</p>


                <!--多选操作-->
                <v-checkbox v-if="$store.state.sceneItemMultipleChoosing"
                            v-model="$store.state.sceneItemMultipleChoosingList" :value="item.sceneId"
                            dark color="#2A82E4" hide-details
                            style="position:absolute;top:-4px;right:-12px;width:24px;height:24px;margin-top:-8px;margin-left:10px;"
                            class="sceneCheckbox">
                </v-checkbox>


              </div>

              <!--配置面板-->
              <div v-show="$store.state.currChooseSceneItemId === item.sceneId && !item.flyAnimationShow" style="margin-top:20px;">
                <!--单点动效-->
                <div v-show="item.viewPointList.length === 1" style="overflow:hidden;">
                  <div @click="choosePointAnimation(item,pointAnimationItem)"
                       v-for="(pointAnimationItem,pointAnimationIndex) in singlePointAnimationList" :key="'pointAnimation'+pointAnimationIndex"
                       :style="{'border':item.pointAnimation === pointAnimationItem.name ? '1px solid #00B3FF' : '1px solid #808080',
                       'margin-right':(pointAnimationIndex + 1)%3===0 ? '0px' : '25px',
                       'cursor':pointAnimationItem.name === '地球自转' && item.sceneZoom > 5 ? '' : 'pointer'}"
                       style="position:relative;width:70px;height:60px;border-radius:5px;margin-bottom:14px;padding-top:5px;background:#383838;float:left;text-align:center;">
                    <p>{{pointAnimationItem.name}}</p>
                    <v-img :src="pointAnimationItem.thumb" contain style="height:22px;margin-top:4px;"></v-img>

                    <!--地球自转蒙层-->
                    <div v-show="pointAnimationItem.name === '地球自转' && item.sceneZoom > 5"
                         style="position:absolute;top:-1px;left:-1px;width:calc(100% + 2px);height:calc(100% + 2px);border-radius:5px;background:rgba(38,38,38,0.5);"></div>
                  </div>
                </div>

                <!--多点动效-->
                <div v-show="item.viewPointList.length !== 1" style="overflow:hidden;">
                  <div @click="item.pointAnimation = pointAnimationItem.name" v-for="(pointAnimationItem,pointAnimationIndex) in multiplePointAnimationList" :key="'pointAnimation'+pointAnimationIndex"
                       :style="{'border':item.pointAnimation === pointAnimationItem.name ? '1px solid #00B3FF' : '1px solid #808080',
                       'margin-right':(pointAnimationIndex + 1)%3===0 ? '0px' : '25px'}"
                       style="width:70px;height:60px;border-radius:5px;margin-bottom:14px;padding-top:5px;background:#383838;float:left;
                     text-align:center;cursor:pointer;">
                    <p>{{pointAnimationItem.name}}</p>
                    <v-img :src="pointAnimationItem.thumb" contain style="height:22px;margin-top:4px;"></v-img>
                  </div>
                </div>

                <!--更多参数设置 v-show=""-->
                <div v-show="item.pointAnimation !== '无效果'">
                  <div @click="pointAnimationParamShow = !pointAnimationParamShow" :style="{'margin-bottom':pointAnimationParamShow ? '10px' : '0'}" style="margin-top:3px;cursor:pointer;">
                    <p>参数设置<span class="iconfontFamily" style="margin-left:4px;">{{pointAnimationParamShow ? '&#xe650;' : '&#xe65c;'}}</span></p>
                  </div>
                  <!--单点 螺旋凝视-->
                  <div v-show="pointAnimationParamShow && item.pointAnimation === '螺旋凝视'" style="position:relative;display:flex;align-items:center;">
                    <p>持续时间</p>
                    <input-number v-model="item.pointAnimationParam.rotate.duration"
                                  width="70" height="27" maxValue="600" minValue="1" unit="秒"
                                  @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                  style="margin-left:14px;"></input-number>
                    <v-spacer></v-spacer>
                    <p>延迟</p>
                    <input-number v-model="item.pointAnimationParam.rotate.timeout"
                                  width="70" height="27" maxValue="10" minValue="0" unit="秒"
                                  @errorValue="errorUploadValue('延迟时间在1秒至10秒之间')"
                                  style="margin-left:14px;"></input-number>
                  </div>
                  <!--单点 太空俯冲-->
                  <div v-show="pointAnimationParamShow && item.pointAnimation === '太空俯冲'" style="position:relative;display:flex;align-items:center;">
                    <p>持续时间</p>
                    <input-number v-model="item.pointAnimationParam.slide.duration"
                                  width="70" height="27" maxValue="600" minValue="1" unit="秒"
                                  @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                  style="margin-left:14px;"></input-number>
                    <v-spacer></v-spacer>
                    <p>延迟</p>
                    <input-number v-model="item.pointAnimationParam.slide.timeout"
                                  width="70" height="27" maxValue="10" minValue="0" unit="秒"
                                  @errorValue="errorUploadValue('延迟时间在1秒至10秒之间')"
                                  style="margin-left:14px;"></input-number>
                  </div>
                  <!--单点 地球自转-->
                  <div v-show="pointAnimationParamShow && item.pointAnimation === '地球自转'">
                    <div style="position:relative;display:flex;align-items:center;">
                      <p>持续时间</p>
                      <input-number v-model="item.pointAnimationParam.earthRotation.duration"
                                    width="70" height="27" maxValue="600" minValue="1" unit="秒"
                                    @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                    style="margin-left:14px;"></input-number>
                      <v-spacer></v-spacer>
                      <p>延迟</p>
                      <input-number v-model="item.pointAnimationParam.earthRotation.timeout"
                                    width="70" height="27" maxValue="10" minValue="0" unit="秒"
                                    @errorValue="errorUploadValue('延迟时间在1秒至10秒之间')"
                                    style="margin-left:14px;"></input-number>
                    </div>
                    <div style="position:relative;margin-top:10px;display:flex;align-items:center;">
                      <p>旋转方向</p>
                      <small-btn-toggle v-model="item.pointAnimationParam.earthRotation.direction" :btnList="pointAnimationParam_directionList" :btnWidth="60" style="margin-left:14px;"></small-btn-toggle>
                    </div>

                  </div>
                  <!--单点 高空悬停-->
                  <div v-show="pointAnimationParamShow && item.pointAnimation === '高空悬停'" style="position:relative;display:flex;align-items:center;">
                    <p>持续时间</p>
                    <input-number v-model="item.pointAnimationParam.zoomSubAndHovering.duration"
                                  width="70" height="27" maxValue="600" minValue="1" unit="秒"
                                  @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                  style="margin-left:14px;"></input-number>
                    <v-spacer></v-spacer>
                    <p>延迟</p>
                    <input-number v-model="item.pointAnimationParam.zoomSubAndHovering.timeout"
                                  width="70" height="27" maxValue="10" minValue="0" unit="秒"
                                  @errorValue="errorUploadValue('延迟时间在1秒至10秒之间')"
                                  style="margin-left:14px;"></input-number>
                  </div>
                  <!--单点 螺旋环绕-->
                  <div v-show="pointAnimationParamShow && item.pointAnimation === '螺旋环绕'">
                    <div style="position:relative;display:flex;align-items:center;">
                      <p>持续时间</p>
                      <input-number v-model="item.pointAnimationParam.zoomAddAndPitchAddAndRotate.duration"
                                    width="70" height="27" maxValue="600" minValue="1" unit="秒"
                                    @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                    style="margin-left:14px;"></input-number>
                      <v-spacer></v-spacer>
                      <p>延迟</p>
                      <input-number v-model="item.pointAnimationParam.zoomAddAndPitchAddAndRotate.timeout"
                                    width="70" height="27" maxValue="10" minValue="0" unit="秒"
                                    @errorValue="errorUploadValue('延迟时间在1秒至10秒之间')"
                                    style="margin-left:14px;"></input-number>
                    </div>
                    <div style="position:relative;margin-top:10px;display:flex;align-items:center;">
                      <p>旋转方向</p>
                      <small-btn-toggle v-model="item.pointAnimationParam.zoomAddAndPitchAddAndRotate.direction" :btnList="pointAnimationParam_directionList" :btnWidth="60" style="margin-left:14px;"></small-btn-toggle>
                    </div>
                  </div>
                  <!--单点 螺旋靠近-->
                  <div v-show="pointAnimationParamShow && item.pointAnimation === '螺旋靠近'">
                    <div style="position:relative;display:flex;align-items:center;">
                      <p>持续时间</p>
                      <input-number v-model="item.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.duration"
                                    width="70" height="27" maxValue="600" minValue="1" unit="秒"
                                    @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                    style="margin-left:14px;"></input-number>
                      <v-spacer></v-spacer>
                      <p>延迟</p>
                      <input-number v-model="item.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.timeout"
                                    width="70" height="27" maxValue="10" minValue="0" unit="秒"
                                    @errorValue="errorUploadValue('延迟时间在1秒至10秒之间')"
                                    style="margin-left:14px;"></input-number>
                    </div>
                    <div style="position:relative;margin-top:10px;display:flex;align-items:center;">
                      <p>旋转方向</p>
                      <small-btn-toggle v-model="item.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.direction" :btnList="pointAnimationParam_directionList" :btnWidth="60" style="margin-left:14px;"></small-btn-toggle>
                    </div>
<!--                    <div style="position:relative;margin-top:10px;display:flex;align-items:center;">-->
<!--                      <p>靠近程度</p>-->
<!--                      <small-btn-toggle v-model="item.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.zoomChange" :btnList="pointAnimationParam_zoomAddAndPitchAddAndRotateZoomAdd_zoomChangeList" :btnWidth="40" style="margin-left:14px;"></small-btn-toggle>-->
<!--                    </div>-->
                  </div>
                  <!--单点 俯冲环绕-->
                  <div v-show="pointAnimationParamShow && item.pointAnimation === '俯冲环绕'">
                    <div style="position:relative;display:flex;align-items:center;">
                      <p>持续时间</p>
                      <input-number v-model="item.pointAnimationParam.zoomAddAndRotate.duration"
                                    width="70" height="27" maxValue="600" minValue="1" unit="秒"
                                    @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                    style="margin-left:14px;"></input-number>
                      <v-spacer></v-spacer>
                      <p>延迟</p>
                      <input-number v-model="item.pointAnimationParam.zoomAddAndRotate.timeout"
                                    width="70" height="27" maxValue="10" minValue="0" unit="秒"
                                    @errorValue="errorUploadValue('延迟时间在1秒至10秒之间')"
                                    style="margin-left:14px;"></input-number>
                    </div>
                    <div style="position:relative;margin-top:10px;display:flex;align-items:center;">
                      <p>旋转方向</p>
                      <small-btn-toggle v-model="item.pointAnimationParam.zoomAddAndRotate.direction" :btnList="pointAnimationParam_directionList" :btnWidth="60" style="margin-left:14px;"></small-btn-toggle>
                    </div>
<!--                    <div style="position:relative;margin-top:10px;display:flex;align-items:center;">-->
<!--                      <p>俯冲高度</p>-->
<!--                      <small-btn-toggle v-model="item.pointAnimationParam.zoomAddAndRotate.zoomChange" :btnList="pointAnimationParam_zoomAddAndRotate_zoomChangeList" :btnWidth="40" style="margin-left:14px;"></small-btn-toggle>-->
<!--                    </div>-->
                  </div>
                  <!--单点 俯冲观测-->
                  <div v-show="pointAnimationParamShow && item.pointAnimation === '俯冲观测'">
                    <div style="position:relative;display:flex;align-items:center;">
                      <p>持续时间</p>
                      <input-number v-model="item.pointAnimationParam.zoomAddAndHovering.duration"
                                    width="70" height="27" maxValue="600" minValue="1" unit="秒"
                                    @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                    style="margin-left:14px;"></input-number>
                      <v-spacer></v-spacer>
                      <p>延迟</p>
                      <input-number v-model="item.pointAnimationParam.zoomAddAndHovering.timeout"
                                    width="70" height="27" maxValue="10" minValue="0" unit="秒"
                                    @errorValue="errorUploadValue('延迟时间在1秒至10秒之间')"
                                    style="margin-left:14px;"></input-number>
                    </div>
                    <div style="position:relative;margin-top:10px;display:flex;align-items:center;">
                      <p>俯冲高度</p>
                      <small-btn-toggle v-model="item.pointAnimationParam.zoomAddAndHovering.zoomChange" :btnList="pointAnimationParam_zoomAddAndRotate_zoomChangeList" :btnWidth="40" style="margin-left:14px;"></small-btn-toggle>
                    </div>

                  </div>


                  <!--多点 平移跟踪-->
                  <div v-show="pointAnimationParamShow && item.pointAnimation === '平移跟踪'"
                       style="position:relative;display:flex;align-items:center;">
                    <p>持续时间</p>
                    <input-number v-model="item.pointAnimationParam.route.duration"
                                  width="70" height="27" maxValue="600" minValue="1" unit="秒"
                                  @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                  style="margin-left:14px;"></input-number>
                    <v-spacer></v-spacer>
                    <p>延迟</p>
                    <input-number v-model="item.pointAnimationParam.route.timeout"
                                  width="70" height="27" maxValue="10" minValue="0" unit="秒"
                                  @errorValue="errorUploadValue('延迟时间在1秒至10秒之间')"
                                  style="margin-left:14px;"></input-number>
                  </div>
                  <!--多点 侧向跟踪-->
                  <div v-show="pointAnimationParamShow && item.pointAnimation === '侧向跟踪'"
                       style="position:relative;display:flex;align-items:center;">
                    <p>持续时间</p>
                    <input-number v-model="item.pointAnimationParam.flyByPathWithChangeBearing.duration"
                                  width="70" height="27" maxValue="600" minValue="1" unit="秒"
                                  @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                  style="margin-left:14px;"></input-number>
                    <v-spacer></v-spacer>
                    <p>延迟</p>
                    <input-number v-model="item.pointAnimationParam.flyByPathWithChangeBearing.timeout"
                                  width="70" height="27" maxValue="10" minValue="0" unit="秒"
                                  @errorValue="errorUploadValue('延迟时间在1秒至10秒之间')"
                                  style="margin-left:14px;"></input-number>
                  </div>

                  <!--多点 空中游览-->
                  <div v-show="pointAnimationParamShow && item.pointAnimation === '空中游览'"
                       style="position:relative;display:flex;align-items:center;">
                    <p>持续时间</p>
                    <input-number v-model="item.pointAnimationParam.zoomAddAndFlyByPath.duration"
                                  width="70" height="27" maxValue="600" minValue="1" unit="秒"
                                  @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                  style="margin-left:14px;"></input-number>
                    <v-spacer></v-spacer>
                    <p>延迟</p>
                    <input-number v-model="item.pointAnimationParam.zoomAddAndFlyByPath.timeout"
                                  width="70" height="27" maxValue="10" minValue="0" unit="秒"
                                  @errorValue="errorUploadValue('延迟时间在1秒至10秒之间')"
                                  style="margin-left:14px;"></input-number>
                  </div>
                  <!--多点 模拟驾驶-->
                  <div v-show="pointAnimationParamShow && item.pointAnimation === '模拟驾驶'"
                       style="position:relative;display:flex;align-items:center;">
                    <p>持续时间</p>
                    <input-number v-model="item.pointAnimationParam.flyByPathWithWatchNextPoint.duration"
                                  width="70" height="27" maxValue="600" minValue="1" unit="秒"
                                  @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                  style="margin-left:14px;"></input-number>
                    <v-spacer></v-spacer>
                    <p>延迟</p>
                    <input-number v-model="item.pointAnimationParam.flyByPathWithWatchNextPoint.timeout"
                                  width="70" height="27" maxValue="10" minValue="0" unit="秒"
                                  @errorValue="errorUploadValue('延迟时间在1秒至10秒之间')"
                                  style="margin-left:14px;"></input-number>
                  </div>


                </div>
              </div>

            </div>

            <!--点后转场-->
            <div @click="$store.state.sceneItemDragging || $store.state.sceneItemMultipleChoosing ? '' : clickSceneItemFlyAnimation(item,index)" v-show="index!==$store.state.sceneList.length - 1">
              <!--转场详情-->
              <div v-show="$store.state.currChooseSceneItemId === item.sceneId && item.flyAnimationShow" :style="{'background':$store.state.currChooseSceneItemId === item.sceneId ? '#262626' : 'transparent',
               'border-color':$store.state.currChooseSceneItemId === item.sceneId ? '#00B3FF' : '#808080'}" class="flyAnimationArea">
                <div style="height:24px;display:flex;align-items: center;">
                  <p style="margin-right:8px;font-size:18px;" class="iconfontFamily">&#xe6aa;</p>
                  <p style="font-size:16px;">转场</p>
                  <v-spacer></v-spacer>
                  <p @click.stop="previewFlyAnimation(item,index)" style="font-size:14px;cursor:pointer;" class="iconfontFamily">&#xe65e;</p>
                </div>
                <!--动效-->
                <div style="margin-top:14px;overflow:hidden;">
                  <div @click="item.flyAnimation = flyAnimationItem.name" v-for="(flyAnimationItem,flyAnimationIndex) in flyAnimationList" :key="'flyAnimation'+flyAnimationIndex"
                       :style="{'border':item.flyAnimation === flyAnimationItem.name ? '1px solid #2A82E4' : '1px solid transparent',
                       'margin-right':(flyAnimationIndex + 1)%4===0 ? '0px' : '5px'}"
                       style="width:63px;height:60px;border-radius:5px;margin-bottom:6px;padding-top:7px;float:left;text-align:center;cursor:pointer;">
                    <p>{{flyAnimationItem.name}}</p>
                    <v-img :src="flyAnimationItem.thumb" contain style="height:18px;margin-top:4px;"></v-img>
                  </div>
                </div>

                <!--切换的更多动效-->
                <div v-show="item.flyAnimation==='切换'" style="margin-bottom:14px;">
                  <div style="width:100%;height:1px;background:#808080;"></div>

                  <div style="width:100%;border:1px solid #4d4d4d;border-radius:2px;margin-top:12px;padding:2px 0 2px 2px;overflow:auto;" class="myScrollArea">
                    <div @click="item.flyAnimationParam.jumpTo.type = jumpToTypeItem.name" v-for="(jumpToTypeItem,jumpToTypeIndex) in flyAnimationParam_jumpToTypeList" :key="'jumpToType'+jumpToTypeIndex"
                         :style="{'border':item.flyAnimationParam.jumpTo.type === jumpToTypeItem.name ? '1px solid #2A82E4' : '1px solid transparent',
                         'margin-right':(jumpToTypeIndex+1)%4===0 ? '0px' : '3px'}"
                         style="width:calc((100% - 11px) * 0.25);height:69px;padding-top:9px;float:left;cursor:pointer;
                         display:flex;flex-direction:column;align-items:center;">
                      <p style="line-height:19px;">{{jumpToTypeItem.name}}</p>
                      <v-img :src="jumpToTypeItem.thumb" contain style="width:25px;margin-top:-8px;"></v-img>
                    </div>
                  </div>
                </div>

                <!--参数设置-->
                <div v-show="item.flyAnimation !== '无'">
                  <div @click="flyAnimationParamShow = !flyAnimationParamShow" :style="{'margin-bottom':flyAnimationParamShow ? '10px' : '0'}" style="margin-top:10px;cursor:pointer;">
                    <p>参数设置<span class="iconfontFamily" style="margin-left:4px;">{{flyAnimationParamShow ? '&#xe650;' : '&#xe65c;'}}</span></p>
                  </div>

                  <!--跳跃-->
                  <div v-show="flyAnimationParamShow && item.flyAnimation === '跳跃'" style="position:relative;display:flex;align-items:center;">
                    <p>持续时间</p>
                    <input-number v-model="item.flyAnimationParam.flyTo.duration" width="65" height="27" maxValue="600" minValue="1" unit="秒"
                                  @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                  style="margin-left:8px;"></input-number>
                    <v-spacer></v-spacer>
                    <p>高度</p>
                    <small-btn-toggle v-model="item.flyAnimationParam.flyTo.minZoom" :btnList="flyAnimationParam_minZoomList" :btnWidth="21" style="margin-left:8px;margin-right:6px;"></small-btn-toggle>
                    <v-tooltip right max-width="300" color="rgba(0, 0, 0, 0.8)">
                      <template v-slot:activator="{ on, attrs }">
                        <p v-bind="attrs" v-on="on" style="color:#c4c4c4;font-size:13px;" class="iconfontFamily">&#xe71f;</p>
                      </template>
                      <span>【高】建议用于跨国家区域跳转；【中】建议用于跨省区域跳转展示；【低】建议用于相邻省及以下区域跳转展示。</span>
                    </v-tooltip>
                  </div>
                  <!--旋转跳跃-->
                  <div v-show="flyAnimationParamShow && item.flyAnimation === '旋转跳跃'" style="position:relative;display:flex;align-items:center;">
                    <p>持续时间</p>
                    <input-number v-model="item.flyAnimationParam.rotateAndFlyTo.duration" width="65" height="27" maxValue="600" minValue="1" unit="秒"
                                  @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                  style="margin-left:8px;"></input-number>
                    <v-spacer></v-spacer>
                    <p>高度</p>
                    <small-btn-toggle v-model="item.flyAnimationParam.rotateAndFlyTo.minZoom" :btnList="flyAnimationParam_minZoomList" :btnWidth="21" style="margin-left:8px;margin-right:6px;"></small-btn-toggle>
                    <v-tooltip right max-width="300" color="rgba(0, 0, 0, 0.8)">
                      <template v-slot:activator="{ on, attrs }">
                        <p v-bind="attrs" v-on="on" style="color:#c4c4c4;font-size:13px;" class="iconfontFamily">&#xe71f;</p>
                      </template>
                      <span>【高】建议用于跨国家区域跳转；【中】建议用于跨省区域跳转展示；【低】建议用于相邻省及以下区域跳转展示。</span>
                    </v-tooltip>
                  </div>
                  <!--平移-->
                  <div v-show="flyAnimationParamShow && item.flyAnimation === '平移'" style="display:flex;align-items:center;">
                    <p>持续时间</p>
                    <input-number v-model="item.flyAnimationParam.easeTo.duration" width="65" height="27" maxValue="600" minValue="1" unit="秒"
                                  @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                  style="margin-left:8px;"></input-number>
                  </div>
                  <!--穿梭-->
                  <div v-show="flyAnimationParamShow && item.flyAnimation === '穿梭'" style="position:relative;display:flex;align-items:center;">
                    <p>持续时间</p>
                    <input-number v-model="item.flyAnimationParam.easeToWithSpeed.duration" width="65" height="27" maxValue="600" minValue="1" unit="秒"
                                  @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                  style="margin-left:8px;"></input-number>
                  </div>
                  <!--回太空-->
                  <div v-show="flyAnimationParamShow && item.flyAnimation === '回太空'" style="position:relative;display:flex;align-items:center;">
                    <p>持续时间</p>
                    <input-number v-model="item.flyAnimationParam.flyToBetweenGlobal.duration" width="65" height="27" maxValue="600" minValue="1" unit="秒"
                                  @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                  style="margin-left:8px;"></input-number>
                  </div>

                  <!--切换-->
                  <div v-show="flyAnimationParamShow && item.flyAnimation === '切换'" style="display:flex;align-items:center;">
                    <p>持续时间</p>
                    <input-number v-model="item.flyAnimationParam.jumpTo.duration" width="65" height="27" maxValue="600" minValue="1" unit="秒"
                                  @errorValue="errorUploadValue('持续时间在1秒至600秒之间')"
                                  style="margin-left:8px;"></input-number>
                  </div>


                  <!--平滑，应用所有-->
                  <div v-show="flyAnimationParamShow" style="margin-top:16px;display:flex;">
<!--                    <p>平滑衔接</p>-->
<!--                    <v-checkbox v-model="item.flyAnimationParam.flyAnimationSmooth" dark color="#2A82E4" hide-details style="width:18px;height:18px;margin-top:-6px;margin-left:3px;" class="sceneCheckbox"></v-checkbox>-->

                    <v-spacer></v-spacer>
                    <p @click="flyAnimationSetAll(item)" style="cursor:pointer;">应用到所有</p>

                  </div>
                </div>



              </div>


              <!--转场缩略-->
              <div v-show="$store.state.currChooseSceneItemId !== item.sceneId || !item.flyAnimationShow" style="width:calc(100% - 26px);margin:10px auto;">
                <p class="flyAnimationSimpleText">
                  <span :style="{'color':item.flyUpdate ? '#FFC300!important' : '#a6a6a6'}" style="margin-right:8px;font-size:18px;" class="iconfontFamily">&#xe6aa;</span>
                  转场-{{item.flyAnimation}}</p>
              </div>
            </div>

            <!--拖拽效果-->
            <!--被拖拽项要插入本项上方-->
            <div v-show="$store.state.sceneItemDragging && sceneItemEndIndex === index && sceneItemEndDirection === 'top'" style="position:absolute;top:-2px;left:0;width:100%;height:1px;background:#00B3FF;"></div>
            <!--被拖拽项要插入本项下方-->
            <div v-show="$store.state.sceneItemDragging && sceneItemEndIndex === index && sceneItemEndDirection === 'bottom'" style="position:absolute;bottom:-2px;left:0;width:100%;height:1px;background:#00B3FF;"></div>

          </div>








        </div>

        <!--播放按钮-->
        <div v-show="!$store.state.sceneItemDragging && !$store.state.sceneItemMultipleChoosing" style="width:100%;height:40px;margin:20px 0 6px 0;">
          <!--正常播放-->
          <div @click="this.$parent.scenePlay" style="width:120px;height:40px;background:#1867C0;border-radius:28px;margin-left:110px;
            color:#ffffff;font-size:14px;cursor:pointer;float:left;display:flex;align-items:center;justify-content: center;">
            <p style="margin-top:2px;margin-right:10px;font-size:20px;" class="iconfontFamily">&#xe725;</p>
            <p>播放</p>
          </div>

<!--          &lt;!&ndash;慢速播放&ndash;&gt;-->
<!--          <v-tooltip right max-width="300" color="rgba(0, 0, 0, 0.8)">-->
<!--            <template v-slot:activator="{ on, attrs }">-->
<!--              <div @click="scenePlayWithSpeed" v-bind="attrs" v-on="on"-->
<!--                   style="width:80px;height:40px;background:rgba(107, 107, 107, 1);border-radius:28px;margin-left:15px;-->
<!--                       color:#ffffff;font-size:14px;cursor:pointer;float:left;">-->
<!--                <p style="margin-left:16px;margin-right:5px;font-size:16px;float:left;line-height:40px;" class="iconfontFamily">&#xe684;</p>-->
<!--                <p style="float:left;line-height:40px;">慢速</p>-->
<!--              </div>-->
<!--            </template>-->
<!--            <span>网络波动时可选择慢速播放</span>-->
<!--          </v-tooltip>-->

        </div>


      </div>





    </div>


    <!--选择文件类型 单点多点等-->
    <choose-scene-type v-if="chooseSceneTypeShow" :dialogShow="chooseSceneTypeShow" @closeDialog="chooseSceneTypeShow = false" @chooseSceneTypeOk="chooseSceneTypeOk"></choose-scene-type>

    <!--新建文件弹窗-->
    <create-scene-folder v-if="createSceneFolderShow" :dialogShow="createSceneFolderShow" @closeDialog="createSceneFolderShow = false" @createFolderOk="createSceneFolderOk"></create-scene-folder>

    <!--打开文件-->
    <choose-scene-folder v-if="chooseSceneFolderShow" :dialogShow="chooseSceneFolderShow" @closeDialog="chooseSceneFolderShow = false" @chooseSceneFolderOk="chooseSceneFolderOk"></choose-scene-folder>

    <!--另存为文件弹窗-->
    <resave-scene-folder v-if="resaveSceneFolderShow" :dialogShow="resaveSceneFolderShow" :oldSceneFolderName="currSceneName" @closeDialog="resaveSceneFolderShow = false" @resaveSceneFolderOk="resaveSceneFolderOk"></resave-scene-folder>

    <!--确定删除录制点-->
    <v-dialog v-model="sceneItemDeleteDialogShow" persistent max-width="540">
      <v-card>
        <v-card-title class="tipsDialog-title">
          温馨提示
          <v-spacer></v-spacer>
          <p @click="sceneItemDeleteDialogShow = false;" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text style="padding:80px 80px 44px 90px">
          <div style="display:flex;align-items:center">
            <p class="tipsDialog-mainArea-icon iconfontFamily">&#xe627;</p>
            <p class="tipsDialog-mainArea-text">录制点删除后将无法恢复<br/>确定删除？</p>
          </div>
          <div class="tipsDialog-mainArea-btnLine">
            <v-btn @click="sceneItemDeleteDialogShow = false;" width="100" height="35" color="#F5F5F5">取消</v-btn>
            <v-btn @click="sceneItemDeleteDialogOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确定</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>



  </div>

</template>

<script>

import InputNumber from "@/components/input_number/InputNumber";
import SmallBtnToggle from "@/components/small_btn_toggle/SmallBtnToggle";

import ChooseSceneType from "@/views/globe/dialog/ChooseSceneType";
import CreateSceneFolder from "@/views/globe/dialog/CreateSceneFolder";
import ChooseSceneFolder from "@/views/globe/dialog/ChooseSceneFolder";
import ResaveSceneFolder from "@/views/globe/dialog/ResaveSceneFolder";

export default {
  name: "MainGlobeScene",
  components:{InputNumber,SmallBtnToggle,ChooseSceneType,CreateSceneFolder,ChooseSceneFolder,ResaveSceneFolder},
  data(){
    return{

      currSceneName:"",
      oldSceneName:"",


      //重命名文件
      editSceneNameShow:"",


      //选择新文件类型
      chooseSceneTypeShow:false,
      defaultFolderChooseSceneType:false,
      //新建文件
      createSceneFolderShow:false,
      //打开文件
      chooseSceneFolderShow:false,
      //另存为文件
      resaveSceneFolderShow:false,







      //录制点//////////////////////////////////////////////////////////////////////

      //重命名录制点
      editSceneItemNameShow:false,
      //动效列表
      singlePointAnimationList:[
        // {
        //   name:"螺旋凝视",
        // },
        // {
        //   name:"太空俯冲",
        // },
        // {
        //   name:"无效果",
        // },

        //新动效
        // {
        //   name:"地球自转",
        //   thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202406271405000142664_thumb.png"
        // },
        {
          name:"无效果",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202406271415000595757_thumb.png"
        },
        // {
        //   name:"高空悬停",
        //   thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/20240627140500036540_thumb.png"
        // },
        {
          name:"螺旋环绕",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202406271406000083322_thumb.png"
        },
        {
          name:"螺旋靠近",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202406271406000219152_thumb.png"
        },
        {
          name:"俯冲环绕",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202406271406000351834_thumb.png"
        },
        // {
        //   name:"俯冲观测",
        //   thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202406271406000461257_thumb.png"
        // },
      ],
      multiplePointAnimationList:[
        //新动效
        // {
        //   name:"侧向跟踪",
        //   thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202406271410000305006_thumb.png"
        // },
        {
          name:"平移跟踪",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202406271410000305006_thumb.png"
        },
        {
          name:"空中游览",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202406271411000326876_thumb.png"
        },
        {
          name:"模拟驾驶",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202406271411000433904_thumb.png"
        },

      ],
      //更多参数设置
      pointAnimationParamShow:false,
      //平移跟踪速度
      pointAnimationParam_routeSpeedList:[
        {
          text:"快",
          value:3000
        },
        {
          text:"中",
          value:5000
        },
        {
          text:"慢",
          value:8000
        },
      ],
      //平移跟踪视野高度
      pointAnimationParam_routeCameraHeightList:[
        {
          text:"高",
          value:12000
        },
        {
          text:"中",
          value:8000
        },
        {
          text:"低",
          value:4000
        },
      ],
      //方向
      pointAnimationParam_directionList:[
        {
          text:"顺时针",
          value:1
        },
        {
          text:"逆时针",
          value:0
        }
      ],
      //螺旋靠近 靠近程度
      pointAnimationParam_zoomAddAndPitchAddAndRotateZoomAdd_zoomChangeList:[
        {
          text:"远",
          value:1
        },
        {
          text:"中",
          value:2
        },
        {
          text:"近",
          value:4
        }
      ],
      //俯冲环绕\俯冲观测 俯冲高度
      pointAnimationParam_zoomAddAndRotate_zoomChangeList:[
        {
          text:"高",
          value:6
        },
        {
          text:"中",
          value:4
        },
        {
          text:"低",
          value:2
        }
      ],



      //转场动效列表
      flyAnimationList:[

        {
          name:"跳跃",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303011104000027858.png"
        },
        {
          name:"旋转跳跃",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202406271415000009070_thumb.png"
        },
        {
          name:"平移",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303011106000455801.png"
        },
        {
          name:"穿梭",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202406271415000233844_thumb.png"
        },
        {
          name:"回太空",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/20240627141500037188_thumb.png"
        },
        {
          name:"切换",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/20230301110700030789.png"
        },
        {
          name:"无",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202406271415000595757_thumb.png"
        },
      ],
      flyAnimationParamShow:true,
      //转场动效参数 高度
      flyAnimationParam_minZoomList:[
        {
          text:"高",
          value:2
        },
        {
          text:"中",
          value:6
        },
        {
          text:"低",
          value:10
        },

      ],
      //转场动效 切换 更多动效
      flyAnimationParam_jumpToTypeList:[
        // {
        //   name:"无",
        //   thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com/202310121710000493112.png"
        // },
        {
          name:"淡出",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/20230302113000004804.png"
        },
        {
          name:"浮入",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303021130000164713.png"
        },
        {
          name:"扩展",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303021130000288496.png"
        },
        {
          name:"百叶窗",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202303021416000529834.png"
        }
      ],


      //进行排序中
      // sceneItemDragging:false,
      //拖拽 源对象的下标
      sceneItemDragIndex: '',
      //拖拽 目标对象的下标（也是经过对象下标）
      sceneItemEndIndex: '',
      sceneItemEndDirection:"",   //被拖拽项要插入目标项的上方top或下方bottom


      //批量删除录制点弹窗
      sceneItemDeleteDialogShow:false,
      deleteType:"",
      deleteSingleIndex:"",


      //录制样例////////////////////////////////////////////////////////////////////////////
      sceneExampleShow:true,







    }

  },

  methods:{
    //文件//////////////////////////////////////////////////////////////////////////////

    //进入初始化文件信息
    initFolderInfo(){
      // this.openFolderById("8c8dd940c4ef4dd684f0b65ef3d42530")
      this.$axios.get('/authorApi/z-screen-recorder/getRecentlyRecordId')
          .then((resultData)=>{
            resultData = resultData.data;
            console.log(resultData)
            if(resultData.status === 200){
              if(resultData.data !== ""){
                //打开该文件夹
                this.openFolderById(resultData.data)
              }
              else{
                //该用户没有上次打开的文件夹，新建默认文件夹
                this.$axios({
                  method:"post",
                  url:"/authorApi/z-screen-recorder/newRecord",
                  params:{
                    recordName:"地球录制1"
                  }
                }).then((resultData_newFile)=>{
                  resultData_newFile = resultData_newFile.data;
                  console.log(resultData_newFile)
                  if(resultData_newFile.status === 200){
                    this.openFolderById(resultData_newFile.data)
                    this.defaultFolderChooseSceneType = true;
                    this.chooseSceneTypeShow = true;
                  }
                  else{
                    console.log(resultData_newFile.status + resultData_newFile.message);
                  }
                }).catch((err)=>{
                  console.log(err);
                });

              }

            }
            else{
              console.log(resultData.status + resultData.message);
            }
          })
          .catch(()=>{

          })
    },


    createNewFolder(){
      this.$parent.isPreviewing(()=>{
        this.chooseSceneTypeShow = true;
      })
    },
    //选择文件类型成功
    chooseSceneTypeOk(){
      if(this.defaultFolderChooseSceneType){
        //已创建默认文件，然后选择类型，进入新文件操作引导
        this.defaultFolderChooseSceneType = false;
        this.chooseSceneTypeShow = false;
        this.newFolderGuide();
      }
      else{
        //正常新建，选择类型后输入文件名新建文件
        this.chooseSceneTypeShow = false;
        this.createSceneFolderShow = true;
      }
    },
    //新建文件成功
    createSceneFolderOk(folderId){
      console.log(folderId)
      //打开该文件夹
      this.openFolderById(folderId)
      this.createSceneFolderShow = false;

      this.$store.state.snackbarShow = true
      this.$store.state.snackbarText = "录制文件新建成功"
      this.$store.state.snackbarType = 'success'

      //新建文件完成
      this.newFolderGuide();

    },
    //开始新文件操作引导
    newFolderGuide(){
      console.log(this.$store.state.sceneType)
      switch(this.$store.state.sceneType){
        case "单点动画": case "地球动画":{
          this.$parent.addScenePointAddFirstViewPoint = false;
          this.$parent.beginAddScenePoint();
          this.$parent.sceneGuideMantle_mapAvailable = true;

          break;
        }
        case "多点跳转":{
          this.$parent.addScenePointAddFirstViewPoint = false;
          this.$parent.beginAddScenePoint();
          this.$parent.sceneGuideMantle_mapAvailable = true;

          break;
        }
        case "自定义动画":{

          break;
        }



      }
    },


    beginChooseFolder(){
      this.$parent.isPreviewing(()=>{
        this.chooseSceneFolderShow = true;
      })
    },
    //选择文件成功
    chooseSceneFolderOk(folderId){
      this.chooseSceneFolderShow = false;
      this.openFolderById(folderId)
    },


    //进入编辑文件夹名称
    intoEditSceneName(e){
      this.editSceneNameShow = true;
      this.oldSceneName = this.currSceneName
      //避免切换时输入栏仅剩一行
      this.currSceneName = this.currSceneName + " "

      //该双击场景名称的下一个元素，是输入框
      let currTextFieldDom = e.target.nextSibling.querySelector("textarea")
      console.log(currTextFieldDom)
      setTimeout(()=>{
        currTextFieldDom.focus()
        currTextFieldDom.select();
      },0)
    },
    editSceneNameOk(){
      if(this.currSceneName.trim().length > 30){
        this.$store.state.snackbarShow=true
        this.$store.state.snackbarText = "文件名超出30字"
        this.$store.state.snackbarType = 'error'

        this.currSceneName = this.oldSceneName

        this.$refs.sceneNameTextarea.focus()
      }
      else if(this.currSceneName.trim().length === 0){
        this.$store.state.snackbarShow=true
        this.$store.state.snackbarText = "文件名不能为空"
        this.$store.state.snackbarType = 'error'

        this.currSceneName = this.oldSceneName

        this.$refs.sceneNameTextarea.focus()
      }
      else{
        this.$axios.get('/authorApi/z-screen-recorder/recordReName',{
          params:{
            'recordId':this.$store.state.currSceneFolderId,
            'recordName':this.currSceneName.trim(),
          }
        }).then((resultData)=>{
          resultData = resultData.data;
          console.log(resultData)
          if(resultData.status === 200){
            this.currSceneName = this.currSceneName.trim();
            this.editSceneNameShow = false;
          }
          else if(resultData.status === 309){
            this.currSceneName = this.oldSceneName
            this.$store.state.snackbarShow=true
            this.$store.state.snackbarText = "已存在同名文件"
            this.$store.state.snackbarType = 'error'

            this.$refs.sceneNameTextarea.focus()
          }
          else{
            console.log(resultData.status + resultData.message);
          }
        }).catch(()=>{

        })
      }

    },

    //打开文件
    openFolderById(folderId){
      console.log(folderId);
      this.$parent.showLoadingDialog = true;

      //地图上数据清空
      //隐藏弹窗
      this.$store.state.sceneViewPointAreaShow = false;

      this.$parent.isMaterialShow(()=>{
        this.$store.state.currChooseSceneItemId = "";
        this.$store.state.currChooseSceneItemIndex = "";
        this.$store.state.tempMaterialInfo = {
          materialList:[],
          materialMarkerData:this.$store.state.defaultMaterialMarkerData
        };
        this.currSceneName = ""
        this.$store.state.sceneList = [];
      })


      this.$store.state.currChooseViewItemId = "";
      this.$store.state.currChooseViewItemIndex = "";
      //清空点位添加过程
      this.$store.state.scenePointEditing = false;
      this.$store.state.sceneOperationState_addViewPointGuideState = "";
      this.$store.state.sceneOperationState_addViewPointRecommendedAnimationShow = false;
      this.$store.state.sceneOperationLayerState = ""
      this.$store.state.sceneViewMarkerSelectingShow = false;
      //视野点栏折叠，自动打开
      if(!this.$parent.viewPointerListOpen){
        this.$parent.changeViewPointerListOpenState()
      }

      this.$store.state.tempViewPointList = [];
      this.$store.state.tempSceneZoomBasis = "";


      this.$axios({
        method:"post",
        url:"/authorApi/z-screen-recorder/openRecord",
        params:{
          recordId:folderId
        }
      }).then(async (resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){
          this.$store.state.globeQuitShowDialog = false;

          for(let i=0;i<resultData.data.sceneList.length;i++){
            //scenePicture的http链接转成base64
            let scenePictureBase64Url = await this.$utils.imageUrlToBase64(resultData.data.sceneList[i].scenePicture
                .replace("https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/","/huaweicloud")
            )
            resultData.data.sceneList[i].scenePicture = scenePictureBase64Url
            //视野点截图转base64
            for(let j=0;j<resultData.data.sceneList[i].viewPointList.length;j++){
              let viewPictureBase64Url = await this.$utils.imageUrlToBase64(resultData.data.sceneList[i].viewPointList[j].viewPicture
                  .replace("https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/","/huaweicloud")
              )
              resultData.data.sceneList[i].viewPointList[j].viewPicture = viewPictureBase64Url
            }

          }

          this.$store.state.sceneList = resultData.data.sceneList;
          console.log(this.$store.state.sceneList)


          this.$store.state.currSceneFolderId = folderId;
          this.currSceneName = resultData.data.recordName;

          this.$parent.showLoadingDialog = false;

          if(this.$store.state.sceneList.length !== 0){
            this.$parent.map.flyTo({
              center:this.$store.state.sceneList[0].sceneCenter,
              zoom:this.$store.state.sceneList[0].sceneZoom,
              bearing:0,
              pitch:0
            })
          }
          else{
            this.$parent.map.flyTo({
              center:this.$parent.initCenter,
              zoom:this.$parent.initZoom,
              bearing:0,
              pitch:0
            })
          }

        }
        else{
          console.log(resultData.status + resultData.message);
          this.$parent.showLoadingDialog = false;
        }
      }).catch((err)=>{
        console.log(err);
        this.$parent.showLoadingDialog = false;
      });

    },

    //保存文件
    saveFolder(){
      this.$parent.isPreviewing(()=>{

        this.$parent.loadingDialogText = "保存中......"
        this.$parent.showLoadingDialog = true;

        this.$parent.isMaterialShow(async ()=>{
          //清除文件中的地球标记信息，将base64转换成http，再打开后重新加载
          let saveSceneList = JSON.parse(JSON.stringify(this.$store.state.sceneList))
          for(let i=0;i<saveSceneList.length;i++){
            saveSceneList[i].materialInfo.materialMarkerData = this.$store.state.defaultMaterialMarkerData;
            saveSceneList[i].materialInfo.materialMarkerUpdate = true;
            saveSceneList[i].scenePicture = await this.$utils.base64ToHttp(saveSceneList[i].scenePicture)
            for(let j=0;j<saveSceneList[i].viewPointList.length;j++){
              saveSceneList[i].viewPointList[j].viewPicture = await this.$utils.base64ToHttp(saveSceneList[i].viewPointList[j].viewPicture)
            }
          }

          this.$axios({
            method:"post",
            url:"/authorApi/z-screen-recorder/editRecord",
            data:{
              recordId:this.$store.state.currSceneFolderId,
              sceneList:saveSceneList,
            }
          }).then((resultData)=>{
            resultData = resultData.data;
            console.log(resultData)
            if(resultData.status === 200){
              console.log("保存文件id：" + this.$store.state.currSceneFolderId)
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "保存成功"
              this.$store.state.snackbarType = 'success'

              this.$store.state.globeQuitShowDialog = false;

              this.$parent.showLoadingDialog = false;
            }
            else{
              console.log(resultData.status + resultData.message);
              this.$parent.showLoadingDialog = false;
            }
          }).catch((err)=>{
            console.log(err);
            this.$parent.showLoadingDialog = false;
          });
        })

      })

    },



    beginResaveFolder(){
      this.$parent.isPreviewing(()=>{
        this.resaveSceneFolderShow = true;
      })
    },
    //另存为文件成功
    resaveSceneFolderOk(folderId){
      this.openFolderById(folderId)
      this.resaveSceneFolderShow = false;

      this.$store.state.snackbarShow=true
      this.$store.state.snackbarText = "文件另存成功"
      this.$store.state.snackbarType = 'success'

    },


    //录制点/////////////////////////////////////////////////////////////////////////////


    //删除录制点
    deleteSceneItem(index){
      this.deleteType = "single";
      this.deleteSingleIndex = index
      this.sceneItemDeleteDialogShow = true;
    },
    //确定删除 单点
    sceneItemSingleDeleteOK(index){
      //取消编辑状态
      this.$parent.viewPointerListCancel()

      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;

      this.sceneItemDeleteDialogShow = false;

      if(this.$store.state.currChooseSceneItemIndex === index){
        this.$parent.isMaterialShow(()=>{
          this.$store.state.currChooseSceneItemId = ""
          this.$store.state.currChooseSceneItemIndex = ""
          this.$store.state.sceneList.splice(index,1);
          if(this.$store.state.currChooseSceneItemIndex > index){
            this.$store.state.currChooseSceneItemIndex --;
          }
        })
        this.$store.state.sceneViewPointAreaShow = false;

      }
      else{
        this.$store.state.sceneList.splice(index,1);
        if(this.$store.state.currChooseSceneItemIndex > index){
          this.$store.state.currChooseSceneItemIndex --;
        }
      }

    },

    //预览录制点
    previewSceneItem(item){
      if(this.$store.state.scenePointEditing){

      }
      else{
        this.$emit("previewSceneItem",item)
      }
    },

    //预览转场
    previewFlyAnimation(item,index){
      if(this.$store.state.scenePointEditing){

      }
      else{
        this.$emit("previewFlyAnimation",{
          currSceneItem:item,
          nextSceneItem:this.$store.state.sceneList[index+1]
        })
      }
    },



    //进入编辑录制点名称
    intoEditSceneItemName(e,item){
      this.$parent.isPreviewing(()=>{
        if(this.$store.state.currChooseSceneItemId === item.sceneId){
          //退出页面时弹出弹窗
          this.$store.state.globeQuitShowDialog = true;

          this.editSceneItemNameShow = true;
          //该双击场景名称的下一个元素，是输入框
          let currTextFieldDom = e.target.nextSibling.querySelector("input")
          setTimeout(()=>{
            currTextFieldDom.focus()
            currTextFieldDom.select();
          },0)
        }
      })
    },




    //点击某个录制点
    clickSceneItem(item,index){
      console.log("点击某个录制点")
      this.$parent.isPreviewing(()=>{

        // this.$store.state.sceneCurrPlayItem = item;

        if(this.$store.state.scenePointEditing){
          //在编辑视野点
          this.$parent.chooseNextSceneItem_notSaveDialogShow = true;
          this.$parent.nextChooseSceneItemType = "sceneItem";
          this.$parent.nextChooseSceneItem = item;
          this.$parent.nextChooseSceneItemIndex = index;
        }
        else{
          if(!this.$parent.clickPreviewBtnBubble){
            //如果不是通过点击预览按钮冒泡到点击录制点，就飞行（预览里不一定是飞行到录制点位置）
            this.$parent.map.flyTo({
              center: item.sceneCenter,
              zoom: item.sceneZoom,
              pitch: item.scenePitch,
              bearing:item.sceneBearing,
            })
          }
          this.$store.state.sceneOperationState_addViewPointGuideState = ""

          this.$parent.isMaterialShow(()=>{
            this.$store.state.currChooseSceneItemId = item.sceneId;
            this.$store.state.currChooseSceneItemIndex = index;
          })

          this.$store.state.currChooseViewItemId = ""
          this.$store.state.currChooseViewItemIndex = ""

          this.$store.state.sceneViewPointAreaShow = true;

          item.flyAnimationShow = false;

          //显示地图上素材marker
          if(!this.$parent.clickPreviewBtnBubble){
            //如果不是通过点击预览按钮冒泡到点击录制点，显示地图上素材marker
            this.$parent.createMaterialMarkerLayer()
            this.$store.state.sceneViewMarkerShow = true;
          }

        }

      })
    },

    //选择某个动效
    choosePointAnimation(item,pointAnimationItem){
      if(pointAnimationItem.name === "地球自转"){
        if(item.sceneZoom <= 5){
          item.pointAnimation = pointAnimationItem.name
        }
      }
      else{
        item.pointAnimation = pointAnimationItem.name
      }
    },


    //点击某个转场
    clickSceneItemFlyAnimation(item,index){
      this.$parent.isPreviewing(()=>{
        if(this.$store.state.scenePointEditing){
          //在编辑视野点
          this.$parent.chooseNextSceneItem_notSaveDialogShow = true;

          this.$parent.nextChooseSceneItemType = "flyAnimation";
          this.$parent.nextChooseSceneItem = item;
          this.$parent.nextChooseSceneItemIndex = index;
        }
        else{
          this.$parent.map.flyTo({
            center: item.sceneCenter,
            zoom: item.sceneZoom,
            pitch: item.scenePitch,
            bearing:item.sceneBearing,
          })

          this.$parent.isMaterialShow(()=>{
            this.$store.state.currChooseSceneItemId = item.sceneId;
            this.$store.state.currChooseSceneItemIndex = index;
          })

          this.$store.state.sceneOperationState_addViewPointGuideState = ""
          this.$store.state.currChooseSceneItemId = item.sceneId;
          this.$store.state.currChooseSceneItemIndex = index;
          item.flyAnimationShow = true;

          if(item.flyUpdate){
            item.flyUpdate = false
          }

          //隐藏素材设置弹窗
          this.$store.state.setMaterialAreaShow = false;

          //删除地图上素材marker
          this.$parent.clearMaterialMarkerLayer()
          this.$store.state.sceneViewMarkerShow = false;
        }

      })
    },


    //转场效果应用到所有
    flyAnimationSetAll(item){
      for(let i=0;i<this.$store.state.sceneList.length-1;i++){
        this.$set(this.$store.state.sceneList[i],"flyAnimation",item.flyAnimation)
        this.$set(this.$store.state.sceneList[i],"flyAnimationParam",JSON.parse(JSON.stringify(item.flyAnimationParam)))
      }
    },




    //录制点操作
    //进入拖拽排序状态
    intoSceneItemDragging(){
      this.$store.state.tempSceneList = JSON.parse(JSON.stringify(this.$store.state.sceneList))
      this.$store.state.sceneItemDragging = true;

      this.sceneOperationClearData();
    },

    //进入多选状态
    intoSceneItemMultipleChoosing(){
      this.$store.state.sceneItemMultipleChoosing = true;
      this.$store.state.sceneItemMultipleChoosingList = [];
      this.sceneOperationClearData();
    },
    //进入录制点操作时清空数据
    sceneOperationClearData(){
      //取消所有选中
      this.$parent.isMaterialShow(()=>{
        this.$store.state.currChooseSceneItemId = "";
        this.$store.state.currChooseSceneItemIndex = "";
      })

      this.$store.state.sceneViewPointAreaShow = false;
      this.$store.state.currChooseViewItemId = "";
      this.$store.state.currChooseViewItemIndex = "";
      //取消所有地球上展示
      this.$store.state.scenePointEditing = false;
      this.$store.state.sceneOperationState_addViewPointGuideState = "";
      this.$store.state.sceneOperationState_addViewPointRecommendedAnimationShow = false;
      this.$store.state.sceneOperationLayerState = ""
    },


    //录制点拖拽排序
    //拖拽确定
    sceneItemDraggingOK(){
      this.$store.state.sceneList = JSON.parse(JSON.stringify(this.$store.state.tempSceneList))
      this.$store.state.sceneItemDragging = false;

      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;
    },


    //开始拖拽，记录被拖拽项的index
    sceneItemDragstart(index) {
      this.sceneItemDragIndex = index
    },
    //拖拽进入目标对象的效果，取消浏览器默认效果
    sceneItemDragover(e, index) {
      e.preventDefault();
      this.sceneItemEndIndex = index
      if(e.offsetY < 52){
        //鼠标在容器项的上半部分
        this.sceneItemEndDirection = "top"
      }
      else{
        //鼠标在容器项的下半部分
        this.sceneItemEndDirection = "bottom"
      }
    },
    //拖拽离开容器元素，去除拖拽中的效果
    sceneItemDragleave(e, index){
      let currViewPointList = this.$store.state.tempSceneList;

      if(index === currViewPointList.length -1 && this.sceneItemEndDirection === "bottom"){
        //离开最后一项的下方
        this.sceneItemEndIndex = ""
        this.sceneItemEndDirection = ""
      }
      else if(index === 0 && this.sceneItemEndDirection === "top"){
        //离开第一项的上方
        this.sceneItemEndIndex = ""
        this.sceneItemEndDirection = ""
      }
    },
    //拖拽完成
    sceneItemDragend(e,index){
      e.preventDefault();
      let currViewPointList = this.$store.state.tempSceneList;

      let currDragItem = currViewPointList[this.sceneItemDragIndex]
      currViewPointList[this.sceneItemDragIndex].flyUpdate = true;

      //列表里删除被拖拽元素
      currViewPointList.splice(this.sceneItemDragIndex, 1);
      //在目标位置插入被拖拽元素
      if(index < this.sceneItemDragIndex){
        //目标位置在被拖拽元素上方
        if(this.sceneItemEndDirection === "top"){
          currViewPointList.splice(index,0,currDragItem)
          currViewPointList[index-1].flyUpdate = true;
        }
        else if(this.sceneItemEndDirection === "bottom"){
          currViewPointList.splice(index+1,0,currDragItem)
          currViewPointList[index].flyUpdate = true;
        }
      }
      else if(index > this.sceneItemDragIndex){
        //目标位置在被拖拽元素下方
        if(this.sceneItemEndDirection === "top"){
          currViewPointList.splice(index-1,0,currDragItem)
          currViewPointList[index-2].flyUpdate = true;
        }
        else if(this.sceneItemEndDirection === "bottom"){
          currViewPointList.splice(index,0,currDragItem)
          currViewPointList[index-1].flyUpdate = true;
        }
      }
      //拖拽完成，清空数据
      this.sceneItemDragIndex = ""
      this.sceneItemEndIndex = ""
      this.sceneItemEndDirection = ""

    },



    //批量删除
    sceneItemMultipleDelete(){
      this.deleteType = "multiple";
      this.sceneItemDeleteDialogShow = true;
    },
    sceneItemMultipleDeleteOK(){
      //退出页面时弹出弹窗
      this.$store.state.globeQuitShowDialog = true;

      this.sceneItemDeleteDialogShow = false;

      let currViewPointList = this.$store.state.sceneList;
      for(let i=0;i<this.$store.state.sceneItemMultipleChoosingList.length;i++){
        for(let j=currViewPointList.length-1;j>=0;j--){
          if(this.$store.state.sceneItemMultipleChoosingList[i] === currViewPointList[j].sceneId){
            if(j!==0){
              //要删除录制点的上一个录制点 转场需更新
              currViewPointList[j-1].flyUpdate = true;
            }
            currViewPointList.splice(j,1)
            break;
          }
        }
      }

      this.$store.state.sceneItemMultipleChoosing = false;
      this.$store.state.sceneItemMultipleChoosingList = [];

    },


    //删除弹窗 确定
    sceneItemDeleteDialogOK(){
      if(this.deleteType === "multiple"){
        //多选 删除
        this.sceneItemMultipleDeleteOK()
      }
      else{
        //单选 删除
        this.sceneItemSingleDeleteOK(this.deleteSingleIndex)
      }


    },



    //////////////////////////////////////////////////////////////////////////////////////

    //打开场景新手引导视频
    openSceneGuideVideo(){
      this.$emit("openSceneGuideVideo","")
    },


    //获取样例列表
    getSceneExampleList(){
      this.$axios({
        method:"get",
        url:"/authorApi/z-screen-recorder-simple/getList",
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){
          this.$store.state.sceneExampleList = resultData.data;

        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },

    //添加样例到场景列表
    //注意：为了减少数据量，样例数据的scenePicture是http链接，实际场景列表中使用需要base64
    addExampleToSceneList(exampleId){
      console.log(exampleId)

      if(this.$store.state.scenePointEditing){
        //在编辑视野点
        this.$parent.chooseExampleItem_notSaveDialogShow = true;
        this.$parent.nextExampleItemId = exampleId;
      }
      else{
        //退出页面时弹出弹窗
        this.$store.state.globeQuitShowDialog = false;

        // //临时读本地txt演示
        // this.showLoadingDialog = true;
        //
        // setTimeout(()=>{
        //   // name为文件所在位置
        //   let name = "./example.txt"
        //   let xhr = new XMLHttpRequest()
        //
        //   xhr.open('GET', name, false)
        //   xhr.overrideMimeType('text/html;charset=utf-8') //默认为utf-8
        //   xhr.send(null)
        //
        //   let i=0;
        //   for(i=0;i<JSON.parse(xhr.responseText).length;i++){
        //     JSON.parse(xhr.responseText)[i].flyPanelOpen = false;
        //     JSON.parse(xhr.responseText)[i].pointPanelOpen = false;
        //   }
        //   this.globeOperationSceneList = JSON.parse(xhr.responseText);
        //   //取消监听跟随鼠标的操作提示
        //   this.map.getCanvas().removeEventListener("mouseenter",this.getGlobeOperationSceneTipPosition_mouseenterFun)
        //
        //   let temp = setInterval(()=>{
        //     if(i === JSON.parse(xhr.responseText).length){
        //       clearInterval(temp)
        //       this.showLoadingDialog = false;
        //     }
        //   },500)
        // },500)


        //正常样例数据
        this.$parent.showLoadingDialog = true

        console.log(exampleId)
        this.$axios({
          method:"get",
          url:"/authorApi/z-screen-recorder-simple/getById",
          params:{
            id:exampleId
          }
        }).then(async (resultData)=>{
          resultData = resultData.data;
          console.log(resultData)
          if(resultData.status === 200){
            for(let i=0;i<resultData.data.content.length;i++){
              resultData.data.content[i].flyPanelOpen = false;
              resultData.data.content[i].pointPanelOpen = false;

              //scenePicture的http链接转成base64
              let base64Url = await this.$utils.imageUrlToBase64(resultData.data.content[i].scenePicture
                  .replace("https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/","/huaweicloud")
              )
              resultData.data.content[i].scenePicture = base64Url

              for(let j=0;j<resultData.data.content[i].viewPointList.length;j++){
                resultData.data.content[i].viewPointList[j].viewPicture = await this.$utils.imageUrlToBase64(resultData.data.content[i].viewPointList[j].viewPicture
                    .replace("https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/","/huaweicloud")
                )

              }
            }
            this.$store.state.sceneList = resultData.data.content;

            console.log(this.$store.state.sceneList)

            // //取消监听跟随鼠标的操作提示
            // this.map.getCanvas().removeEventListener("mouseenter",this.getGlobeOperationSceneTipPosition_mouseenterFun)

            this.$parent.showLoadingDialog = false
          }
          else{
            console.log(resultData.status + resultData.message);
            this.$parent.showLoadingDialog = false
          }
        }).catch((err)=>{
          console.log(err);
          this.$parent.showLoadingDialog = false
        });
      }


    },





    //错误toast
    errorUploadValue(val){
      this.$store.state.snackbarShow=true
      this.$store.state.snackbarText = val
      this.$store.state.snackbarType = 'error'
    },

    //操作栏 打开地球设置
    openGlobeSet(){
      this.$emit("openGlobeSet","")
    },

  },




  destroyed() {
    this.$emit("leftBarDestroy","globeScene")
  },

  mounted(){

    //当前没有录制文件，初始化文件
    this.initFolderInfo();
    this.getSceneExampleList();

    //初始进入页面，添加视野点图层和各类素材图层
    let temp = setInterval(()=>{
      console.log(this.$parent.mapboxInit)
      if(this.$parent.mapboxInit){
        clearInterval(temp);
        this.$parent.intoGlobeOperationScene();
        this.$parent.createMaterialMarkerLayer()
        this.$store.state.sceneViewMarkerShow = true;
      }
    },100)

  }


}
</script>

<style scoped>
.mainGlobeScene{
  height:100%;
  padding:20px 11px 14px 11px;
  color:#ffffff;
  /*overflow:auto;*/
  display: flex;
  flex-direction: column;
}

/*菜单栏*/
.moreOperationItem{
  height:35px;
  margin:5px 0;
  padding-left:24px;
  font-size:14px;
  color:#ffffff;
  cursor:pointer;
}
.moreOperationItem p{
  line-height:35px;
}
.moreOperationItem:hover{
  background:#20518A;
}


/*编辑文件夹名称*/
.editSceneNameTextField{
  padding-top:0;
  margin-top:-0.5px;
  /*margin-left: -2px;*/
  border-bottom:1px solid #ffffff;
  font-size:18px;
}


/*录制点*/
.sceneItem{
  width:calc(100% - 20px);
  margin:0 auto;
  border:1px solid #808080;
  border-radius:5px;
  padding:12px 15px 12px 15px;
  font-size:14px;
}
.sceneItem:hover{
  border:1px solid #00B3FF!important;
}
.sceneItem-btn{
  margin-right:3px;
  display:none;
  cursor:pointer;
}
.sceneItem:hover .sceneItem-btn{
  display:block;
}
/*编辑录制点名称*/
.editSceneItemNameTextField{
  padding-top:0;
  margin-top:-1px;
  font-size:14px;
}



/*转场*/
.flyAnimationArea{
  width:calc(100% - 20px);
  margin:10px auto;
  border:1px solid #808080;
  border-radius:5px;
  padding:11px 11px 11px 11px;
  font-size:14px;
}
.flyAnimationSimpleText{
  line-height:24px;
  font-size:16px;
  color:#A6A6A6;
  cursor:pointer;
}
.flyAnimationSimpleText:hover{
  color:#ffffff;
}
.flyAnimationSimpleText:hover span{
  color:#ffffff !important;
}





</style>


<style>

/*编辑文件夹和录制点名称*/
.editSceneNameTextField .v-input__slot:before{
  border:none !important;
}
.editSceneNameTextField .v-input__slot:after{
  border:none !important;
}

/*多选框*/
.sceneCheckbox .v-input--selection-controls__ripple{
  display:none;
}
.sceneCheckbox .v-icon{
  font-size:18px;
}


</style>